<div class="row">
    <div class="col-lg-12">
        <h5>Notifications</h5>
        <div class="row action-toolbar">
            <div class="col-12">
                <form class="form-inline">
                    <action-toolbar-count [grid]="grid"></action-toolbar-count>
                    <action-toolbar-search name="search" [(ngModel)]="grid.filter"></action-toolbar-search>
                </form>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <wj-flex-grid
                    id="mainGrid"
                    #mainGrid
                    style="height: 250px"
                    (initialized)="grid.initialize(mainGrid)"
                    (destroy)="grid.destroy()"
                    [itemsSource]="grid.view"
                    [itemFormatter]="itemFormatter"
                    (selectionChanged)="onSelectionChange()"
                >
                    <wj-flex-grid-filter></wj-flex-grid-filter>
                    <wj-flex-grid-column
                        [header]="'Date'"
                        [binding]="'sentDate'"
                        [width]="180"
                        [format]="'MM/dd/yyyy hh:mm tt'"
                    ></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Subject'" [binding]="'title'" [width]="'*'" [isReadOnly]="true"></wj-flex-grid-column>
                </wj-flex-grid>
            </div>
        </div>
        <div class="row" [hidden]="!grid.selectedItem" style="margin-top: 5px">
            <div class="col-12">
                <h6>{{ grid.selectedItem?.title }}</h6>
                <quill-view
                    style="display: block; margin-bottom: 10px; height: 188px"
                    [content]="grid.selectedItem?.richBody"
                    theme="snow"
                ></quill-view>

                <!-- <div appAutoSize style="border: 1px solid lightgray; padding: 10px">
                    {{ grid.selectedItem?.body }}
                </div> -->
            </div>
        </div>
    </div>
</div>
